import { render } from "./LicenseWarning.vue?vue&type=template&id=3232920c"
import script from "./LicenseWarning.vue?vue&type=script&lang=js"
export * from "./LicenseWarning.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LicenseWarning.vue"]])

export default __exports__